<template>
  <div class="customerBox">
    <div class="nav">
      <img src="/rechargeImg/back.png" alt="" @click="goback"/>
      <span class="title">充值</span>
    </div>
    <!-- <div class="rechargeTip">
      <div class="left">
        <img src="/rechargeImg/zs.png" alt="" />
        <span>钻石</span>
      </div>
      <div class="right">
        <span>{{ diamond }}</span>
      </div>
    </div> -->
    <div class="moneyBox">
      <!-- <div class="title">充值金额</div> -->
      <div class="list">
        <div class="item" :class="chooseJson.pid == item.pid ? 'active' : ''" v-for="item in list" :key="item.pid" @click="chooseClick(item)">
          <div class="text">
            <span>{{ toFixed(item.diamond, 0) }}</span>
            <img src="/rechargeImg/zs.png" alt="" />
          </div>
          <div class="price">
            <span>¥{{ toFixed(item.money, 1) }}</span>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 100%;height: 240px;"></div>
    <div class="payType">
      <!-- <div class="list">
        <div class="left">
          <img src="/rechargeImg/zfb.png" alt="" />
          <span>支付宝</span>
        </div>
        <div class="right">
          <img @click="payTypeClick(1001)" :src="payType == 1001 ? '/rechargeImg/select_active.png' : '/rechargeImg/select.png'" alt="" />
        </div>
      </div> -->
      <!-- <div class="list">
        <div class="left">
          <img src="/rechargeImg/wx.png" alt="" />
          <span>微信支付</span>
        </div>
        <div class="right">
          <img @click="payTypeClick(1002)" :src="payType == 1002 ? '/rechargeImg/select_active.png' : '/rechargeImg/select.png'" alt="" />
        </div>
      </div> -->
      <div class="totalPrice">
        <div class="top">
          <div class="left">共计：¥{{ toFixed(chooseJson.money, 1) }}</div>
          <div class="right" @click="rechargeSubmit">立即购买</div>
        </div>
        <div class="bottom"><img @click="agreementClick" :src="agreementFlag ? '/rechargeImg/select_active.png' : '/rechargeImg/select.png'" alt="" /><span>充值即代表同意</span><span @click="toOpenAgreement" style="color: #2a2a2a">《小麦语音支付协议》</span></div>
      </div>
    </div>
  </div>
</template>

<script>
// import { getDiamond } from '../../api/pay'
import { Toast } from 'vant'
export default {
  name: 'customerRecharge',
  data() {
    return {
      payType: 1001,
      agreementFlag: false,
      diamond: 0,
      chooseJson: {
        pid: '',
        diamond: 0,
        money: '0.0',
      },
      list: [],
    }
  },
  mounted() {
    // let token = JSON.parse(JSON.stringify(location.search.split('=')[1]))
    // localStorage.setItem('token', token)
    console.log('cs0.0');
    this.getList()
  },
  methods: {
    agreementClick() {
      this.agreementFlag = !this.agreementFlag
    },
    payTypeClick(type) {
      this.payType = type
    },
    chooseClick(item) {
      this.chooseJson = item
    },
    toFixed(num, type) {
      console.log(num)
      return parseFloat(num).toFixed(type)
    },
    getList() {
      this.handlerWebkitFunction('getRecharge', {}, (result) => {
        let data = result.data
        console.log(result)
        if (result.status == 1) {
          this.diamond = data.diamond
          this.list = JSON.parse(data.list)
        }
      })
    },
    // getList() {
    //   console.log(location);
    //   getDiamond((result) => {
    //     console.log(result)
    //     let data = result.data
    //     this.list = data.list
    //   })
    // },
    handlerWebkitFunction(name, params, callback) {
      let that = this
      var callbackName = name + 'Callback'
      window.webkit.messageHandlers[name].postMessage(
        JSON.stringify({
          ...params,
          callbackName,
        })
      )
      window[callbackName] = function(res) {
        callback && callback(JSON.parse(that.$Base64.decode(res)))
      }
    },

    //   充值
    rechargeSubmit() {
      if (this.agreementFlag) {
        if (this.chooseJson.pid != '') {
          let params = {
            pid: this.chooseJson.pid,
            type: 1001
          }
          this.handlerWebkitFunction('getPayRecharge', params, (result) => {
              console.log(result)
              if (result.data.status == 1) {
                this.getList()
            }
          })
        } else {
          Toast('请选择充值钻石数量')
        }
      } else {
        Toast('请阅读并勾选协议')
      }
    },
    // 小麦语音充值协议
    toOpenAgreement(){
      // this.$router.replace('/usAgreement?code=PAY_AGREEMENT&type=ios')
      // window.webkit.messageHandlers.openWebView.postMessage(JSON.stringify({url: location.origin+'/usAgreement?code=PAY_AGREEMENT&type=ios'}))
      this.handlerWebkitFunction('openWebView', {url: location.origin+'/usAgreement?code=PAY_AGREEMENT&type=ios'})
    },
    // 返回页面
    goback() {
      this.handlerWebkitFunction('over')
    }
  }
}
</script>

<style lang="less" scoped>
.customerBox {
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(345deg, #ffffff 0%, #e6deee 68%, #fffec3 100%, #e9ffaa 43%);
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  .nav {
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    position: relative;
    font-size: 15px;
    font-weight: bold;
    font-family: MiSans-Medium, MiSans;
    color: #373737;
    img {
      position: absolute;
      width: 7px;
      left: 10px;
      top: 20px;
    }
  }
  .rechargeTip {
    width: 94%;
    height: 60px;
    background: #fff;
    margin: 0 auto;
    border-radius: 7px;
    .left {
      float: left;
      width: 40%;
      height: 100%;
      img {
        float: left;
        width: 20px;
        margin: 23px 10px;
        margin-right: 5px;
      }
      span {
        float: left;
        width: calc(100% - 70px);
        line-height: 60px;
        color: #c57110;
        font-weight: 500;
        font-family: MiSans-Medium, MiSans;
      }
    }
    .right {
      float: right;
      width: 50%;
      margin-right: 15px;
      text-align: right;
      height: 100%;
      line-height: 60px;
      font-size: 16px;
      color: #c57110;
      font-weight: 900;
    }
  }
  .moneyBox {
    width: 94%;
    height: auto;
    margin: 10px auto;
    .title {
      width: 100%;
      height: 40px;
      line-height: 40px;
      color: #000000;
      font-weight: bold;
    }

    .list {
      width: 100%;
      height: auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-content: space-between;
      .item {
        width: 30%;
        height: 100px;
        background: #fff;
        margin-bottom: 15px;
        border: 5px solid #fff;
        border-radius: 10px;
        margin-right: 5%;
        &:nth-child(3n) {
          margin-right: 0;
        }
        .text {
          width: 100%;
          height: 40px;
          line-height: 40px;
          font-weight: 900;
          text-align: center;
          font-size: 18px;
          margin-top: 10px;
          img {
            display: inline-block;
            width: 20px;
            vertical-align: inherit;
            margin-left: 5px;
          }
        }
        .price {
          width: 100%;
          text-align: center;
          height: 20px;
          line-height: 20px;
          font-weight: 600;
          font-size: 18px;
        }
      }
      .active {
        border: 5px solid #fceab9;
      }
    }
  }

  .payType {
    position: fixed;
    left: 0;
    bottom: 0;
    background: #fff;
    width: 100%;
    height: auto;
    .list {
      width: 100%;
      height: 70px;
      line-height: 70px;
      border-bottom: 1px solid #e2e2e2;
      .left {
        float: left;
        width: 70%;
        height: 100%;
        font-weight: 600;
        img {
          float: left;
          width: 20px;
          margin: 26px;
          margin-right: 10px;
          margin-left: 15px;
        }
      }
      .right {
        float: right;
        width: 20%;
        height: 100%;
        img {
          float: right;
          margin-right: 15px;
          width: 20px;
          margin-top: 25px;
        }
      }
    }
    .totalPrice {
      width: 100%;
      height: 100px;
      .top {
        width: 100%;
        height: 60px;
        line-height: 60px;
        .left {
          float: left;
          width: 60%;
          height: 100%;
          margin-left: 15px;
          font-weight: 600;
          font-size: 18px;
        }
        .right {
          float: right;
          width: 84px;
          height: 35px;
          margin: 10px;
          margin-right: 15px;
          background-color: #f9eb34;
          text-align: center;
          line-height: 35px;
          color: #000000;
          border-radius: 1000px;
        }
      }
      .bottom {
        width: 100%;
        height: 30px;
        line-height: 30px;
        text-align: left;
        margin-left: 15px;
        font-size: 12px;

        span {
          color: #d2d2d2;
        }
        img {
          display: inline-block;
          width: 15px;
          vertical-align: middle;
          margin-right: 5px;
        }
      }
    }
  }
}
</style>
